/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 *  Possible values: Routemized = 1, Manual = 2
 */
export enum Routemize_Constants_ScheduleMethod {
    ROUTEMIZED = 'Routemized',
    MANUAL = 'Manual',
}
